// extracted by mini-css-extract-plugin
module.exports = {"requestSpinner":"BaseSpinner_requestSpinner_24vcW","spinnerText":"BaseSpinner_spinnerText_2sWUC","baseSpinner":"BaseSpinner_baseSpinner_2bO-K"};